export default "__VITE_ASSET__86be7c65__"